import { render, staticRenderFns } from "./MemberEdit.vue?vue&type=template&id=3540a0a0"
import script from "./MemberEdit.vue?vue&type=script&lang=js"
export * from "./MemberEdit.vue?vue&type=script&lang=js"
import style0 from "./MemberEdit.vue?vue&type=style&index=0&id=3540a0a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports